import { Button } from "snap-design-system";
import { Save, X } from "lucide-react";
import { cn } from "~/lib/utils";

interface ReportEditControlsProps {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
  show: boolean;
}

export function ReportEditControls({
  onSave,
  onCancel,
  isSaving,
  show,
}: ReportEditControlsProps) {
  return (
    <div
      className={cn(
        "flex gap-2 transition-all duration-300 ease-in-out origin-bottom",
        show
          ? "opacity-100 scale-100 translate-y-0"
          : "opacity-0 scale-95 translate-y-4 pointer-events-none"
      )}
    >
      <Button
        size={"small"}
        variant="ghost"
        onClick={onCancel}
        disabled={isSaving}
        className="hover:opacity-70"
        icon={<X size={16} />}
        iconPosition="right"
        title="Cancelar alterações"
      >
        Cancelar
      </Button>
      <Button
        size={"small"}
        onClick={onSave}
        disabled={isSaving}
        icon={<Save size={16} />}
        iconPosition="right"
        title="Salvar alterações"
      >
        {isSaving ? "Salvando..." : "Salvar alterações"}
      </Button>
    </div>
  );
}
